<div 
    class="gift-code" 
    [ngClass]="{'from-ebook': contentType == 'ebook'}" 
    (click)="openModalGift()">
    ¿Tienes un código de acceso?
</div>
